import { useEffect, useRef } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../stores/auth-store";
import { stopRefreshTimer } from "../../lib/token-refresh";

export function LoggedOutPage() {
  const clearedRef = useRef(false);

  useEffect(() => {
    if (clearedRef.current) return;
    clearedRef.current = true;
    stopRefreshTimer();
    useAuthStore.getState().clearTokens();
  }, []);

  return <Navigate to="/sso/login" replace />;
}
